import axios from "axios";

export default async function getIp() {
  let jsonResponse = {};
  try {
    let respuesta = await axios.get("https://api64.ipify.org/?format=json", {});
    let ip = respuesta.data.ip;
    jsonResponse["ip"] = ip;
  } catch (error) {}

  //   try {
  //     const ubicacion = await obtenerUbicacion();
  //     jsonResponse.latitude = ubicacion.latitude;
  //     jsonResponse.longitude = ubicacion.longitude;
  //   } catch (error) {}

  return jsonResponse;
}

async function obtenerUbicacion() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const ubicacion = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          resolve(ubicacion);
        },
        (error) => {
          reject(`Error al obtener la ubicación: ${error.message}`);
        }
      );
    } else {
      reject("La geolocalización no es compatible en este navegador.");
    }
  });
}
